import { Dictionary } from '@shared/interfaces/dictionary';
import { Markets, Market } from './market.models';
import { dtfDanishCompanyData } from '@shared/config/market/data/market.data.dtf';
import {
    semboSwedishCompanyData,
    semboNorwegianCompanyData,
    semboDanishCompanyData,
    semboFinnishCompanyData,
    semboGermanCompanyData,
    semboPolishCompanyData,
    semboDutchCompanyData,
    semboBritishCompanyData,
    semboIrishCompanyData,
    semboAustrianCompanyData,
    semboHungarianCompanyData,
    semboAustralianCompanyData,
    semboNewZealanderCompanyData,
    semboNorthAmericanCompanyData,
    semboCanadianCompanyData,
    semboSouthAfricanCompanyData,
    semboSingaporeanCompanyData,
    semboSpanishCompanyData,
    semboPortugueseCompanyData,
    semboArabicEmiratesCompanyData,
    semboBulgarianCompanyData,
    semboCzechCompanyData,
    semboIndianCompanyData,
    semboPhilippineCompanyData,
    semboNigerianCompanyData,
    semboMexicanCompanyData,
    semboArgentinianCompanyData,
    semboColombianCompanyData,
    semboChileanCompanyData,
    semboPeruvianCompanyData,
    semboEcuadorianCompanyData,
    semboUruguayanCompanyData,
    semboIsraeliCompanyData,
    semboCroatianCompanyData,
    semboIndonesianCompanyData,
    semboSouthKoreanCompanyData,
    semboMalaysianCompanyData,
    semboBelgianCompanyData,
    semboBrazilianCompanyData,
    semboRomanianCompanyData,
    semboSerbianCompanyData,
    semboRussianCompanyData,
    semboSlovakianCompanyData,
    semboThaiCompanyData,
    semboVietnameseCompanyData,
    semboTaiwaneseCompanyData,
    semboHongKongeseCompanyData,
    semboSwissCompanyData,
    semboGreekCompanyData,
    semboBahrainiCompanyData,
    semboBelarusianCompanyData,
    semboBolivianCompanyData,
    semboChineseCompanyData,
    semboCubanCompanyData,
    semboCypriotCompanyData,
    semboDominicanCompanyData,
    semboEgyptianCompanyData,
    semboEstonianCompanyData,
    semboFrenchCompanyData,
    semboIcelandicCompanyData,
    semboIranianCompanyData,
    semboItalianCompanyData,
    semboJapaneseCompanyData,
    semboJordanianCompanyData,
    semboKazakhCompanyData,
    semboKuwaitiCompanyData,
    semboLuxembourgishCompanyData,
    semboMalteseCompanyData,
    semboOmaniCompanyData,
    semboParaguayanCompanyData,
    semboQatariCompanyData,
    semboSaudiCompanyData,
    semboTurkishCompanyData,
    semboUkrainianCompanyData,
    semboVenezuelanCompanyData,
} from '@shared/config/market/data/market.data.sembo';
import {
    stenaSwedishCompanyData,
    stenaNorwegianCompanyData,
    stenaDanishCompanyData,
    stenaFinnishCompanyData,
    stenaGermanCompanyData,
    stenaPolishCompanyData,
    stenaDutchCompanyData,
    stenaBritishCompanyData,
    stenaIrishCompanyData,
} from '@shared/config/market/data/market.data.stena';

export const informationByMarketNumber: Dictionary<Market> = {
    1: semboSwedishCompanyData,
    4: semboNorwegianCompanyData,
    5: semboDanishCompanyData,
    6: semboFinnishCompanyData,
    7: semboGermanCompanyData,
    8: semboPolishCompanyData,
    9: semboDutchCompanyData,
    10: semboBritishCompanyData,
    11: semboIrishCompanyData,
    12: semboAustrianCompanyData,
    13: semboHungarianCompanyData,
    14: semboAustralianCompanyData,
    15: semboNewZealanderCompanyData,
    16: semboNorthAmericanCompanyData,
    17: semboCanadianCompanyData,
    18: semboSouthAfricanCompanyData,
    19: semboSingaporeanCompanyData,
    20: semboSpanishCompanyData,
    21: semboPortugueseCompanyData,
    23: semboArabicEmiratesCompanyData,
    24: semboBulgarianCompanyData,
    25: semboCzechCompanyData,
    26: semboIndianCompanyData,
    27: semboPhilippineCompanyData,
    28: semboNigerianCompanyData,
    29: semboMexicanCompanyData,
    30: semboArgentinianCompanyData,
    31: semboColombianCompanyData,
    32: semboChileanCompanyData,
    33: semboPeruvianCompanyData,
    34: semboEcuadorianCompanyData,
    35: semboUruguayanCompanyData,
    36: semboIsraeliCompanyData,
    37: semboCroatianCompanyData,
    38: semboIndonesianCompanyData,
    39: semboSouthKoreanCompanyData,
    40: semboMalaysianCompanyData,
    41: semboBelgianCompanyData,
    42: semboBrazilianCompanyData,
    43: semboRomanianCompanyData,
    44: semboSerbianCompanyData,
    45: semboRussianCompanyData,
    47: semboSlovakianCompanyData,
    48: semboThaiCompanyData,
    49: semboVietnameseCompanyData,
    50: semboTaiwaneseCompanyData,
    51: semboHongKongeseCompanyData,
    52: semboSwissCompanyData,
    53: semboGreekCompanyData,
    54: semboBahrainiCompanyData,
    55: semboBelarusianCompanyData,
    56: semboBolivianCompanyData,
    57: semboChineseCompanyData,
    58: semboCubanCompanyData,
    59: semboCypriotCompanyData,
    60: semboDominicanCompanyData,
    61: semboEgyptianCompanyData,
    62: semboEstonianCompanyData,
    63: semboFrenchCompanyData,
    64: semboIcelandicCompanyData,
    65: semboIranianCompanyData,
    66: semboItalianCompanyData,
    67: semboJapaneseCompanyData,
    68: semboJordanianCompanyData,
    69: semboKazakhCompanyData,
    70: semboKuwaitiCompanyData,
    71: semboLuxembourgishCompanyData,
    72: semboMalteseCompanyData,
    73: semboOmaniCompanyData,
    74: semboParaguayanCompanyData,
    75: semboQatariCompanyData,
    76: semboSaudiCompanyData,
    77: semboTurkishCompanyData,
    78: semboUkrainianCompanyData,
    79: semboVenezuelanCompanyData,
    101: stenaSwedishCompanyData,
    104: stenaNorwegianCompanyData,
    105: stenaDanishCompanyData,
    106: stenaFinnishCompanyData,
    107: stenaGermanCompanyData,
    108: stenaPolishCompanyData,
    109: stenaDutchCompanyData,
    110: stenaBritishCompanyData,
    111: stenaIrishCompanyData,
    405: dtfDanishCompanyData,
};

export const marketNumberByHost: Dictionary<number> = {
    'sembo.se': 1,
    'sembo.no': 4,
    'sembo.dk': 5,
    'sembo.fi': 6,
    'sembo.de': 7,
    'sembo.pl': 8,
    'sembo.nl': 9,
    'sembo.co.uk': 10,
    'sembo.ie': 11,
    'sembo.at': 12,
    'sembo.hu': 13,
    'sembo.com.au': 14,
    'sembo.nz': 15,
    'sembo.com': 16,
    'sembo.ca': 17,
    'sembo.co.za': 18,
    'sembo.sg': 19,
    'sembo.es': 20,
    'sembo.pt': 21,
    'ae.sembo.com': 23,
    'sembo.bg': 24,
    'cz.sembo.com': 25,
    'sembo.in': 26,
    'ph.sembo.com': 27,
    'ng.sembo.com': 28,
    'sembo.com.mx': 29,
    'sembo.com.ar': 30,
    'sembo.com.co': 31,
    'sembo.cl': 32,
    'sembo.pe': 33,
    'sembo.com.ec': 34,
    'sembo.com.uy': 35,
    'sembo.co.il': 36,
    'hr.sembo.com': 37,
    'id.sembo.com': 38,
    'kr.sembo.com': 39,
    'my.sembo.com': 40,
    'sembo.be': 41,
    'sembo.com.br': 42,
    'sembo.ro': 43,
    'rs.sembo.com': 44,
    'sembo.ru': 45,
    'sk.sembo.com': 47,
    'th.sembo.com': 48,
    'vn.sembo.com': 49,
    'tw.sembo.com': 50,
    'hk.sembo.com': 51,
    'ch.sembo.com': 52,
    'sembo.gr': 53,
    'bh.sembo.com': 54,
    'by.sembo.com': 55,
    'bo.sembo.com': 56,
    'cn.sembo.com': 57,
    'cu.sembo.com': 58,
    'cy.sembo.com': 59,
    'do.sembo.com': 60,
    'eg.sembo.com': 61,
    'sembo.ee': 62,
    'sembo.fr': 63,
    'sembo.is': 64,
    'ir.sembo.com': 65,
    'it.sembo.com': 66,
    'jp.sembo.com': 67,
    'jo.sembo.com': 68,
    'kz.sembo.com': 69,
    'kw.sembo.com': 70,
    'lu.sembo.com': 71,
    'mt.sembo.com': 72,
    'om.sembo.com': 73,
    'py.sembo.com': 74,
    'qa.sembo.com': 75,
    'sa.sembo.com': 76,
    'tr.sembo.com': 77,
    'ua.sembo.com': 78,
    've.sembo.com': 79,
    'sembo.stenaline.se': 101,
    'sembo.stenaline.no': 104,
    'sembo.stenaline.dk': 105,
    'sembo.stenaline.fi': 106,
    'sembo.stenaline.de': 107,
    'sembo.stenaline.pl': 108,
    'sembo.stenaline.nl': 109,
    'sembo.stenaline.co.uk': 110,
    'sembo.stenaline.ie': 111,
    'dtf-travel.dk': 405,
};

export const EU_MARKETS = [
    Markets.AUSTRIA,
    Markets.BELGIUM,
    Markets.BULGARIA,
    Markets.CROATIA,
    Markets.CYPRUS,
    Markets.CZECHREPUBLIC,
    Markets.DENMARK,
    Markets.ESTONIA,
    Markets.FINLAND,
    Markets.FRANCE,
    Markets.GERMANY,
    Markets.GREECE,
    Markets.HUNGARY,
    Markets.IRELAND,
    Markets.ITALY,
    Markets.LUXEMBOURG,
    Markets.MALTA,
    Markets.NETHERLANDS,
    Markets.NORWAY,
    Markets.POLAND,
    Markets.PORTUGAL,
    Markets.ROMANIA,
    Markets.SLOVAKIA,
    Markets.SPAIN,
    Markets.SWEDEN,
];

export const STENA_COMPANIES = [
    Markets.STENASWEDEN,
    Markets.STENANORWAY,
    Markets.STENADENMARK,
    Markets.STENAFINLAND,
    Markets.STENAGERMANY,
    Markets.STENAPOLAND,
    Markets.STENANETHERLAND,
    Markets.STENAUNITEDKINGDOM,
    Markets.STENAIRELAND,
];

export const AVAILABLE_SEMBONUS_MARKETS = [Markets.SWEDEN, Markets.DENMARK, Markets.NORWAY];
